module.exports = {"140426101":"东阳关镇","140426102":"上遥镇","140426103":"西井镇","140426104":"黄崖洞镇","140426105":"黎侯镇","140426106":"洪井镇","140426107":"西仵镇","140426108":"程家山镇","140426400":"黎城县经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140426.json
// module id = 387
// module chunks = 0